import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import _ from 'lodash';
import Translate from '../Translate';
import saveValue from '../../../services/Form/saveValue';

const AlertModal = (props) => {
  let escapeQuestionBtn;
  let submitFormBtn;
  let submitNewFormBtn;
  let missingInfosBody;
  let inputEscapeQuestionBody;
  let _input;
  const {
    isOpen,
    onClose,
    message,
    addNewBtn,
    formId,
    togglePostForm,
    title,
    postNewFormBtn,
    // syncImages,
    // totalImages,
  } = props;
  const [missingInfosDisplay, setMissingInfosDisplay] = useState(true);
  const [disabelSubmitBtn, setDisabelSubmitBtn] = useState(true);
  const [inputEscapeQuestionValue, setInputEscapeQuestionValue] = useState('');

  const inputChange = () => {
    if (_input.value.length === 0) setDisabelSubmitBtn(true);
    else setDisabelSubmitBtn(false);
    if (_input.value) setInputEscapeQuestionValue(_input.value);
  };

  const validateEscapeQuestion = async () => {
    await saveValue(formId, 'inspection.escape_question', inputEscapeQuestionValue);
    await togglePostForm();
  };

  const validateNewForm = async () => {
    await togglePostForm();
  };

  const handleClose = async () => {
    setMissingInfosDisplay(true);
    onClose();
  };

  // const checkMessageItem = () => {
  //   if (!message) return false;
  //   message.forEach((i) => Object.keys(i)[0] !== 'car_pictures' && Object.keys(i)[0] !== 'vin');
  //   return false;
  // };

  // const showMissingTitle = () => {
  //   if (!message || (message && checkMessageItem() === false && syncImages?.length > 0)) return false;
  //   return true;
  // };

  // if (addNewBtn && message && syncImages?.length === 0) {
  if (addNewBtn) {
    escapeQuestionBtn = (
      <button
        type="button"
        className="btn btn-2 px-4 shadow"
        data-cy="escapeQuestionBtn"
        onClick={() => setMissingInfosDisplay(false)}
      >
        <Translate code="alert_modal_escape_question_label" />
      </button>
    );
    submitFormBtn = (
      <button
        type="button"
        className={`btn px-4 shadow ${disabelSubmitBtn ? 'btn-4' : 'btn-1'}`}
        disabled={disabelSubmitBtn}
        data-cy="submitFormBtn"
        onClick={() => validateEscapeQuestion()}
      >
        <Translate code="alert_modal_escape_question_label_valid" />
      </button>
    );
  }

  if (postNewFormBtn) {
    submitNewFormBtn = (
      <button
        type="button"
        className="btn btn-2 px-4 shadow"
        data-cy="validateNewFormBtn"
        onClick={() => validateNewForm()}
      >
        <Translate code="alert_modal_escape_question_label_valid" />
      </button>
    );
  }

  if (missingInfosDisplay) {
    if (typeof message === 'string') {
      missingInfosBody = <Translate code={message} />;
    } else {
      missingInfosBody = (
        <div>
          {(message?.[1] && Object.prototype.hasOwnProperty.call(message[1], 'buyerName') && (
            <Translate code={message[0]} buyerName={message[1].buyerName} />
          )) ||
            _.flatMap(message).map((section) => {
              // if (['car_pictures', 'vin'].includes(Object.keys(section)[0]) && syncImages?.length > 0) return null;
              return (
                <div key={Object.keys(section)[0]}>
                  <Translate code={typeof section === 'string' && section} buyerName={section.buyerName} />
                  <Translate code={Object.keys(section)[0]} />
                </div>
              );
            })}
        </div>
      );
    }
  } else {
    inputEscapeQuestionBody = (
      <div>
        <label className="pl-2 text-left">
          <Translate code="why_escape_question_label" />
        </label>
        <input
          id="escapeQuestionText"
          name="escapeQuestionText"
          data-cy="escapeQuestionText"
          type="text"
          className="text-center form-control"
          onChange={() => inputChange()}
          ref={(input) => {
            _input = input;
            return _input;
          }}
        />
      </div>
    );
  }

  return (
    <Modal isOpen={isOpen} centered>
      {/* {typeof message === 'object' && showMissingTitle() && ( */}
      <ModalHeader>
        <Translate code={title} />
      </ModalHeader>
      {/* )} */}
      <ModalBody className="pb-0">
        <div className="p-3">
          <div>{missingInfosDisplay ? missingInfosBody : inputEscapeQuestionBody}</div>
        </div>
        {/* {(syncImages?.length > 0 && ( */}
        {/*  <div className="d-flex align-items-center flex-column"> */}
        {/*    <Spinner size="sm" /> */}
        {/*    <Translate code={`${(message && 'pictureLoadingPopUp') || 'pictureLoadingPopUp1'}`} /> */}
        {/*    <strong> */}
        {/*      {`${(syncImages?.length - totalImages?.length) * -1}/${totalImages?.length} ${t('pictureLoadingPopUp2')}`} */}
        {/*    </strong> */}
        {/*  </div> */}
        {/* )) || */}
        {/*  (!message && syncImages?.length === 0 && ( */}
        {/*    <div className="d-flex align-items-center flex-column"> */}
        {/*      <Spinner size="sm" /> */}
        {/*      <Translate code="pictureLoadingPopUp1" /> */}
        {/*    </div> */}
        {/*  ))} */}
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <button type="button" className="btn btn-3" onClick={handleClose}>
          {/* {(message && syncImages?.length === 0 && <Translate code="cancel" />) || */}
          <Translate code="cancel" />
        </button>
        {missingInfosDisplay ? escapeQuestionBtn : submitFormBtn}
        {postNewFormBtn ? submitNewFormBtn : ''}
      </ModalFooter>
    </Modal>
  );
};

export default AlertModal;

AlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  addNewBtn: PropTypes.bool.isRequired,
  formId: PropTypes.string.isRequired,
  togglePostForm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  postNewFormBtn: PropTypes.bool,
  // syncImages: PropTypes.oneOfType([PropTypes.array]),
  // totalImages: PropTypes.oneOfType([PropTypes.array]),
};

AlertModal.defaultProps = {
  postNewFormBtn: false,
  // syncImages: [],
  // totalImages: [],
};
